import { initAlgolia } from './algolia-init.js';

let originalParent = null;
let originalNextSibling = null;
let currentMode = window.innerWidth < 768 ? 'mobile' : 'desktop';

export function initAlgoliaMobileDrawer() {
  const drawerId = 'filter-drawer';

  const createDrawer = () => {
    const facets = document.querySelector('.ais-facets');
    const toggleButton = document.querySelector('.ais-facets-button');

    if (!facets || !toggleButton) return;
    if (document.getElementById(drawerId)) return;

    if (!originalParent) {
      originalParent = facets.parentNode;
      originalNextSibling = facets.nextElementSibling;
    }

    facets.classList.add('ais-facets__shown');
    toggleButton.removeAttribute('data-action');

    const newToggleButton = toggleButton.cloneNode(true);
    toggleButton.replaceWith(newToggleButton);

    const drawer = document.createElement('div');
    drawer.id = drawerId;
    drawer.className = 'filter-drawer';

    const drawerContent = document.createElement('div');
    drawerContent.className = 'filter-drawer-content';

    const drawerHeader = document.createElement('div');
    drawerHeader.className = 'filter-drawer-header';

    const headerTitle = document.createElement('span');
    headerTitle.className = 'filter-drawer-title';
    headerTitle.textContent = 'Filters';

    const closeBtn = document.createElement('div');
    closeBtn.className = 'close-btn';
    closeBtn.innerHTML = '&times;';

    drawerHeader.appendChild(headerTitle);
    drawerHeader.appendChild(closeBtn);
    drawerContent.appendChild(drawerHeader);


    const scrollArea = document.createElement('div');
    scrollArea.className = 'filter-scroll-area';

    const pageWrapper = document.createElement('div');
    pageWrapper.className = 'ais-page';
    pageWrapper.appendChild(facets);

    scrollArea.appendChild(pageWrapper);
    drawerContent.appendChild(scrollArea);
    drawer.appendChild(drawerContent);


    const mainContent = document.getElementById('MainContent') || document.body;
    mainContent.appendChild(drawer);

    newToggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.classList.add('open');
      document.documentElement.classList.add('hside_opened');
    });

    closeBtn.addEventListener('click', () => {
      drawer.classList.remove('open');
      document.documentElement.classList.remove('hside_opened');
    });
  };

  const destroyDrawer = () => {
    const drawer = document.getElementById(drawerId);
    const facets = document.querySelector('.ais-facets');

    if (drawer && facets && originalParent) {
      drawer.remove();

      if (originalNextSibling) {
        originalParent.insertBefore(facets, originalNextSibling);
      } else {
        originalParent.appendChild(facets);
      }
    }
  };

  if (currentMode === 'mobile') {
    createDrawer();
  } else {
    destroyDrawer();
  }

  window.addEventListener('resize', () => {
    const newMode = window.innerWidth < 768 ? 'mobile' : 'desktop';
    if (newMode !== currentMode) {
      currentMode = newMode;
      destroyDrawer();
      initAlgolia(false);
    }
  });
}
